export * from './page-banner.module';
